import { render, staticRenderFns } from "./ProductIphone.vue?vue&type=template&id=7a6615ba"
import script from "./ProductIphone.vue?vue&type=script&lang=js"
export * from "./ProductIphone.vue?vue&type=script&lang=js"
import style0 from "./ProductIphone.vue?vue&type=style&index=0&id=7a6615ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports